/**
 * LLMPage — Backward-compatible wrapper
 *
 * Renders AICommandCenterPage with Models tab selected.
 * Preserved for backward compatibility with existing ViewRegistry
 * entry ('llm') and any direct navigation references.
 *
 * Phase 4.7 — WQ-164
 */
import React from 'react';
import AICommandCenterPage from './AICommandCenterPage';

const LLMPage: React.FC = () => {
  return <AICommandCenterPage defaultTab="models" />;
};

export default LLMPage;
